import { z } from "zod";

export const packagingSolutionOptionsSchema = z.object({
	prioritizeProductionBy: z.string(),
	maxFailedProductionRetries: z.number(),
});

export type PackagingSolutionOptions = z.infer<typeof packagingSolutionOptionsSchema>;
